import { Chip, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { I18nNamespace } from '~/common/types';
import { RouteId } from '~/routes';

interface NegotiationCaseLinkChipProps {
  id?: string;
  sequenceNumber?: number;
}

export const NegotiationCaseLinkChip = ({ id, sequenceNumber }: NegotiationCaseLinkChipProps) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'NegotiationCaseLinkChip' });
  if (!id || !sequenceNumber) {
    return null;
  }
  return (
    <Chip
      label={
        <Link component={RouterLink} to={RouteId.negotiationDetail(id)}>
          {t('label', { sequenceNumber: sequenceNumber })}
        </Link>
      }
    />
  );
};
